import React, { useContext } from "react";
import InputsContext from "../contexts/InputsContext";
import { findInputs } from "../concerns/findInputs";

const NextButton = ({ lastStepInput }) => {
  const { inputs, setInputs } = useContext(InputsContext);
  const thisStepInputs = findInputs(inputs, inputs.currentIndex);

  const nextStep = () => {
    inputs.currentIndex += 1;
    setInputs({ ...inputs });
  };

  return (
    <div
      onClick={() => nextStep()}
      className={`px-8 py-6 w-60 flex items-center justify-center bg-orange-500 text-white text-2xl font-bold rounded-lg cursor-pointer ${
        thisStepInputs.valid && thisStepInputs.index != lastStepInput.index
          ? "block"
          : "hidden"
      }`}
    >
      Continuer
    </div>
  );
};

export default NextButton;
